import { useContext } from 'react';
import { TealiumContext } from '../providers/TealiumProvider';
var useTealium = function () {
  return useContext(TealiumContext);
};
export default useTealium;